 import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

const VerifyEmail = () => {
  const [message, setMessage] = useState("Verifying...");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");

  useEffect(() => {
    const verify = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/verify-email?token=${token}`) //changed

        setStatus("success");
        setMessage("Email verified successfully! 🎉");

        // redirect after 2 sec
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);

      } catch (err) {
        setStatus("error");
        setMessage("Invalid or expired verification link ❌");
      }
    };

    verify();
  }, [token]);

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "linear-gradient(135deg, #1e1e2f, #3a0ca3)",
      color: "#fff",
      textAlign: "center"
    }}>
      <div style={{
        background: "#111",
        padding: "40px",
        borderRadius: "12px",
        width: "350px",
        animation: "fadeIn 0.8s ease-in-out"
      }}>
        <h2>📧 Email Verification</h2>

        {status === "loading" && <p>⏳ Verifying...</p>}
        {status === "success" && <p style={{ color: "#4caf50" }}>{message}</p>}
        {status === "error" && <p style={{ color: "#ff4d4d" }}>{message}</p>}

      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default VerifyEmail;